module.exports = __webpack_public_path__ + "img/antrego_black_logo.fd035828.svg";